export default "__VITE_ASSET__ab3fe3c9__"